import { ICON } from './icons';

// TODO: Export new icon from Figma for unmanaged
export const CONTROL_MODE = {
  STANDARD: {
    key: 'Standard',
    label: 'Standard',
    icon: ICON.CONTROL_MODE.ELEXITY,
  },
  PRECONDITION: {
    key: 'Preconditioning',
    label: 'Preconditioning',
    icon: ICON.CONTROL_MODE.ELEXITY,
  },
  RELAX: {
    key: 'Relaxing',
    label: 'Relaxing',
    icon: ICON.CONTROL_MODE.ELEXITY,
  },
  RAMPING_IN: {
    key: 'Ramping In',
    label: 'Ramping In',
    icon: ICON.CONTROL_MODE.ELEXITY,
  },
  RAMPING_OUT: {
    key: 'Ramping Out',
    label: 'Ramping Out',
    icon: ICON.CONTROL_MODE.ELEXITY,
  },
  EVENT: {
    key: 'Event',
    label: 'Event',
    icon: ICON.CONTROL_MODE.EVENT,
  },
  LOCAL_OVERRIDE: {
    key: 'Local Override',
    label: 'Local Override',
    icon: ICON.CONTROL_MODE.OVERRIDE,
  },
  REMOTE_OVERRIDE: {
    key: 'Remote Override',
    label: 'Remote Override',
    icon: ICON.CONTROL_MODE.OVERRIDE,
  },
  UNMANAGED: {
    key: 'Unmanaged',
    label: 'Unmanaged',
    icon: ICON.ACTIVITY.UNMANAGED,
  },
  OFFLINE: {
    key: 'Offline',
    label: 'Offline',
    icon: ICON.ACTIVITY.OFFLINE,
  },
  DEFAULT: {
    key: 'Default',
    label: 'Default',
    icon: ICON.ACTIVITY.UNMANAGED,
  },
};
